import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import successToast from "../helper-components/success-toast";
import errorToast from "../helper-components/error-toast";
import {
  attachedRolesDepartmentListAction,
  departmentListAction,
  RolesListAction,
} from "../../redux/actions/general-action";
import { Field, Form, Formik } from "formik";
import LoadingSpinner from "../helper-components/loading-spinner";
import AddButton from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import SelectField from "../forms/select-field";
import {
  attachedRolesDepartmentCreateAction,
  attachedRolesDepartmentDeleteAction,
  departmentSearchListAction,
  roleSearchListAction,
} from "../../redux/actions/settings-action";

function DepartmentAndRoles({ pageLoading, setPageLoading, searchValue }) {
  const [initialData, setItemTypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [depList, setDepList] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");

  const tableHeading = ["Dept Code/Name", "Role", "Action"];
  const initialValues = {
    data: initialData,
    department: "",
    roles: [],
  };

  const dispatch = useDispatch();
  const onSuccess = (data) => {
    setItemTypeData(data?.data?.rows);
    setLoading(false);
    console.log("department and roles loaded successfully", data.data);
  };
  const onSaveSuccess = (data) => {
    fetchData();
    setPageLoading(false);
    successToast(data?.message);
  };
  const onSaveError = (data) => {
    fetchData();
    setPageLoading(false);
    errorToast(data?.message);
  };

  const onError = (data) => {
    setLoading(false);
    errorToast(data?.message);
  };
  function fetchData(searchValue) {
    if (loading) {
      return;
    }

    setLoading(true);
    dispatch(
      attachedRolesDepartmentListAction(searchValue, onSuccess, onError)
    );
  }

  useEffect(() => {
    dispatch(departmentSearchListAction("", onSuccessDep, onErrorDep));
    dispatch(roleSearchListAction("", onSuccessRoles, onErrorRoles));
    fetchData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 800);

    return () => clearTimeout(timer);
  }, [searchValue]);

  useEffect(() => {
    if (debouncedSearchValue !== "" || searchValue === "") {
      fetchData(debouncedSearchValue);
    }
  }, [debouncedSearchValue]);

  const onSuccessDep = (data) => {
    console.log("Department list fetched successfully", data.data.rows);
    setDepList(
      data?.data?.rows?.map((item) => ({
        label: item?.department_name,
        value: item?.department_id,
      }))
    );
  };
  const onErrorDep = (data) => {};
  const onSuccessRoles = (data) => {
    setRolesList(
      data?.data?.rows?.map((item) => ({
        label: item?.role_name,
        value: item?.role_id,
      }))
    );
  };
  const onErrorRoles = (data) => {};
  const handleAdd = (values) => {
    if (values.department && values.roles.length > 0) {
      console.log("Adding roles to department", values);
      const data = {
        department_id: values.department,
        roles_id: values.roles.map((role) => role.value),
      };
      console.log("Data to be sent", data);
      dispatch(
        attachedRolesDepartmentCreateAction(data, onSaveSuccess, onSaveError)
      );
    }
  };

  const onClickRow = (item, values, setFieldValue) => {
    console.log("Row clicked", item);
    setFieldValue("department", item?.department_id);
    let roles = item?.roles?.map((role) => ({
      label: role?.role_name,
      value: role?.role_id,
    }));
    setFieldValue("roles", roles || []);
  };
  const onclickDelete = (roleId) => {
    if (!pageLoading) {
      setPageLoading(true);
      dispatch(
        attachedRolesDepartmentDeleteAction(
          { department_id: roleId },
          onSaveSuccess,
          onSaveError
        )
      );
    }
  };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      //   onSubmit={onSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form className="pt-1">
          <div
            className="flex flex-col justify-between  rounded-xl"
            style={{ height: "70vh" }}
          >
            {console.log(depList, rolesList, "depList, rolesList")}
            <div className="flex mb-6">
              <SelectField
                labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                label="Departments"
                general_color="true"
                borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                isContainer={true}
                containerClass={"w-full flex flex-col gap-2 mr-4"}
                parentClass={"w-full flex flex-col gap-2 "}
                errMsgContainerClass="hidden"
                placeholder="Search Departments"
                options={depList}
                name={`department`}
                isSearchable={true}
                isRequired={false}
              />
              <SelectField
                labelClass={` text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                label="Assigned Roles"
                // isDisabled={values.department.name?.length > 0 ? false : true}
                general_color="true"
                isMulti={true}
                borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                isContainer={true}
                containerClass={"w-full flex flex-col gap-2 mr-2"}
                parentClass={"w-full flex flex-col gap-2"}
                errMsgContainerClass="hidden"
                placeholder="Search Roles"
                options={rolesList}
                name={`roles`}
                defaultValue={values.roles}
                isSearchable={true}
                isRequired={false}
              />
              <div className="mt-auto">
                <AddButton
                  onclkFn={() => handleAdd(values)}
                  className="mt-auto h-[42px] w-[64px]
                   whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)] 
    font-[var(--primary-button-font-weight)]"
                  prefixIcon={false}
                  text="Add"
                  type="button"
                />
              </div>
            </div>
            {console.log("values", values)}
            {loading ? (
              <LoadingSpinner />
            ) : (
              <div className="overflow-auto mb-auto rounded-xl table-container border border-gray-200">
                <table className=" w-full ">
                  <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                    <tr className="relative h-[50px]">
                      {tableHeading.map((heading, index) => (
                        <th
                          className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                          key={heading}
                        >
                          {heading}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {console.log("values", values)}
                    {values?.data?.map((item, index) => (
                      <tr
                        key={index}
                        onClick={() => onClickRow(item, values, setFieldValue)}
                        className="cursor-pointer hover:bg-black-10"
                      >
                        <td
                          className={`tab-cell text-sm fw_400 text-secondary w-2/12`}
                        >
                          <label className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2">
                            {item?.department_code}-{item?.department_name}
                          </label>
                        </td>
                        <td
                          className={`tab-cell text-sm fw_400 text-secondary w-4/12`}
                        >
                          {item?.roles?.length > 0 ? (
                            <div className="flex flex-wrap gap-2">
                              {item?.roles?.map((row, rowIndex) => (
                                <label
                                  key={rowIndex}
                                  className="bg-[#DBEAFE] rounded-lg px-5 py-1  text-[#1E40AF]"
                                >
                                  {row?.role_name}
                                </label>
                              ))}
                            </div>
                          ) : (
                            <label className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2">
                              No roles assigned
                            </label>
                          )}
                        </td>

                        <td className="tab-cell align-middle text-sm fw_400 text-secondary w-1/12">
                          <div className="flex  items-center">
                            <button
                              onClick={() => onclickDelete(item?.department_id)}
                            >
                              <DeleteIcon />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default DepartmentAndRoles;
